import { readJsonStorage, writeJsonStorage } from "./storage.js";
import type { GameId } from "@hunch/core";

type LastOptionsBag = Partial<Record<GameId, unknown>>;

/** Reads this game's slice of the single `lastOptions` localStorage key (spec §2). */
export function readLastOptions<T>(gameId: GameId): T | null {
  const bag = readJsonStorage<LastOptionsBag>("lastOptions");
  return (bag?.[gameId] as T | undefined) ?? null;
}

/** Writes this game's slice without disturbing other games' saved options. */
export function writeLastOptions<T>(gameId: GameId, value: T): void {
  const bag = readJsonStorage<LastOptionsBag>("lastOptions") ?? {};
  writeJsonStorage("lastOptions", { ...bag, [gameId]: value });
}
